module.exports = __webpack_public_path__ + "static/media/31.c5f8acfa.png";